import { render, staticRenderFns } from "./HouseholdWastePerCapita.vue?vue&type=template&id=2b8c8814&"
import script from "./HouseholdWastePerCapita.vue?vue&type=script&lang=js&"
export * from "./HouseholdWastePerCapita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports